export default "__VITE_ASSET__BgPdJTNz__"